module.exports = __webpack_public_path__ + "img/online_icon.d20f9d4e.svg";